// const api_versions = 19
const api_version = process.env.REACT_APP_API_VERSION;
export class WebApiCalls {
  // HOST_NAME
  HOST_NAME = `${process.env.REACT_APP_FRX_API_URL}/estore/`;
  HOST_NAME_ICOLUMN = `${process.env.REACT_APP_FRX_API_URL}/icolumn/proxy`;
  REACT_APP_FRHUB_API_URL = `${process.env.REACT_APP_FRHUB_API_URL}`;
  //END POINTS

  //GET TOKEN
  _GET_TOKEN = "token";

  //GET USER INFO
  _GET_USER_INFO = "api/v2/users/";

  // LOGOUT ARCADIER USER
  _LOGOUT_ARCADIER_USER = "api/v2/accounts/sign-out";

  //GET ITEMS
  _GET_ITEMS = "api/v2/items/?created=";
  _GET_ITEMS_a = "&-created=";
  _GET_ITEMS_2 = "&updated=";
  _GET_ITEMS_2a = "&-updated=";
  _GET_ITEMS_3 = "&price=";
  _GET_ITEMS_3a = "&-price=";
  _GET_ITEMS_4 = "&PageSize=";
  _GET_ITEMS_5 = "&PageNumber=";
  _GET_ITEMS_6 = "&keywords=";
  _GET_ITEMS_7 = "&Sort=";

  //USERS PART OF HOST    ---> need userID after that
  _USERS = "api/v2/users/";

  //ADD ITEM To CART , Get Cart , delete item from cart  ---> Items after UserID
  _ADD_GET_ITEM = "/carts/";

  //GET INVOICE ---> after UserID
  _GET_INVOICE = "/invoices/carts/";

  //ADD ADDRESS ---> Items after UserID
  _ADDRESS = "/addresses/";

  //get 1 item by id
  _GET_SINGLE_ITEM = "api/v2/items/";

  //GET MERCHANT ADDRESS after user id
  _GET_MERCHANT_ADDRESS = "?includes=addresses";

  _GET_CART_DETAILS = "getarcadiercart?userId=";

  //Payment
  _GET_HASH = "2c2p/paymenttoken";

  //get shippment method of
  _GET_MERCHANT_SHIPMENT_ID = "get_merchant_shipping_id";

  /// Update Custom Fields
  _SET_CUSTOMFILEDS = "generic_custom_field";

  // GET ALL Categories
  _GET_ALL_CATEGORIES_HIERARCHY = "api/v2/categories/hierarchy";
  _GET_ALL_CATEGORIES = "api/v2/categories";

  // get shop name
  _GET_SHOP_NAME = "getshopsname";

  //get brnads Name
  _GET_BRANDS_NAME = "getbrandsname";

  //get all user invoice
  _GET_ALL_INVOICES = "/transactions?";
  //pageSize=100&pageNumber=1";
  // get invoice stattus
  _GET_ALL_MERCHANTS = "get_all_merchants";
  _GET_INVOICE_STATUS = "api/v2/plugins/"; //add plugin
  _GET_INVOICE_STATUS_2 = "/custom-tables/invoices/";
  _GET_FEATURED_PRODUCTS = "get_featured_products";
  _GET_FEATURED_STORES = "get_featured_merchants";
  _GET_SETTINGS = "get_app_settings";
  _GET_MOST_PURCHASED = "most_purchased_products";
  USER_LOGIN = "auth/login";
  USER_LOGOUT = "auth/logout";
  RECOVER_CREDENTIALS = "user/recover_credential";
  TOKRI_POPOVERS = "popoversfrontend";
  TOKRI_FEATUREDBRANDS = "featuredbrands";
  TOKRI_MENUBANNERS = "menubannersfrontend";
  TOKRI_SHOUTOUTS = "shoutoutsfrontend";
  TOKRI_VERIFY_CODE = "campaigns/codeusage";

  // Track Product Views
  _TRACK_PRODUCT_VIEWS = "/track/product-views";

trackProductViews(productId) {
    let url = `${process.env.REACT_APP_FRX_API_URL}${this._TRACK_PRODUCT_VIEWS}`;
    let request = {
      method: "POST",
      body: JSON.stringify({"productId": productId}),
      headers: {
        "Content-Type": "application/json"
      },
    };
    return this.sendRequest(url, request);
  }

  async sendRequest(url, request) {
    try {
      let response = await fetch(url, request);
      let responseJson = await response.json();
      return responseJson;
    } catch (error) {
      let err = [];
      err.error = error;
      err.no_result = true;
      return err;
    }
  }
  getToken(tokenObj) {
    let url = `${this.HOST_NAME}${this._GET_TOKEN}`;
    let request = {
      method: "POST",
      body: JSON.stringify({
        contactID: tokenObj.contactID,
        email: tokenObj.email,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: tokenObj.authentication,
      },
    };
    return this.sendRequest(url, request);
  }
  getUserInfo(userID) {
    let url = `${this.HOST_NAME}${this._GET_USER_INFO}${userID}`;
    let request = {
      method: "GET",
    };
    return this.sendRequest(url, request);
  }
  updateUserInfo(userID, body, accessToken) {
    let url = `${this.HOST_NAME}${this._GET_USER_INFO}${userID}`;
    let request = {
      method: "PUT",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    return this.sendRequest(url, request);
  }

  getItems(itemobj) {
    let url = `${this.HOST_NAME}${this._GET_ITEMS}
        ${this._GET_ITEMS_6}${itemobj.keywords}${this._GET_ITEMS_4}${itemobj.pageSize}${this._GET_ITEMS_5}${itemobj.pageNumber}${this._GET_ITEMS_7}${itemobj.Sort}
        `;
    let request = {
      method: "GET",
    };
    return this.sendRequest(url, request);
  }
  getSingleItem(itemid) {
    let url = `${this.HOST_NAME}${this._GET_SINGLE_ITEM}${itemid}`;
    let request = {
      method: "GET",
    };
    return this.sendRequest(url, request);
  }
  addItem(userID, itemObj, accessToken) {
    let url = `${this.HOST_NAME}${this._USERS}${userID}${this._ADD_GET_ITEM}`;
    let request = {
      method: "POST",
      body: JSON.stringify(itemObj),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    return this.sendRequest(url, request);
  }
  seeCart(userID, accessToken) {
    let url = `${this.HOST_NAME}${this._USERS}${userID}${this._ADD_GET_ITEM}`;
    let request = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    return this.sendRequest(url, request);
  }
  getCartDetail(userID, accessToken) {
    let url = `${this.HOST_NAME}${this._GET_CART_DETAILS}${userID}`;
    let request = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    return this.sendRequest(url, request);
  }
  getInvoice(userID, itemObj, accessToken) {
    let url = `${this.HOST_NAME}${this._USERS}${userID}${this._GET_INVOICE}`;
    let request = {
      method: "POST",
      body: JSON.stringify(itemObj),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    return this.sendRequest(url, request);
  }
  deleteItemCart(userID, accessToken, cartItemID) {
    let url = `${this.HOST_NAME}${this._USERS}${userID}${this._ADD_GET_ITEM}${cartItemID}`;
    let request = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    return this.sendRequest(url, request);
  }
  updateItemCart(userID, accessToken, cartItemID, obj) {
    let url = `${this.HOST_NAME}${this._USERS}${userID}${this._ADD_GET_ITEM}${cartItemID}`;
    let request = {
      method: "PUT",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    return this.sendRequest(url, request);
  }
  // addAddress(userID, itemObj, accessToken) {
  //     let url = `${this.HOST_NAME}${this._USERS}${userID}${this._ADDRESS}`;
  //     let request = {
  //         method: 'POST',
  //         body: JSON.stringify(itemObj),
  //         headers: {
  //             'Content-Type': 'application/json',
  //             'Authorization': 'Bearer ' + accessToken
  //         },
  //     };
  //     return this.sendRequest(url, request);
  // }
  getMerchantAdrress = (merchantId) => {
    let url = `${this.HOST_NAME}${this._USERS}${merchantId}${this._GET_MERCHANT_ADDRESS}`;
    let request = {
      method: "GET",
    };
    return this.sendRequest(url, request);
  };
  getAllAddress = (securityToken) => {
    let url = `${this.HOST_NAME_ICOLUMN}`;
    // security_token: 'xxaSD8lAuEX3r32dddfp3foiowf12TTs',

    let data = {
      fn: "get_address_list",
      // security_token: securityToken,
      // contact_id: contactId,
      version: api_version,
      website: true,
    };

    let request = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: securityToken,
      },
    };
    return this.sendRequest(url, request);
  };
  getPaymentToken = (sessionToken) => {
    let url = `${this.HOST_NAME_ICOLUMN}`;
    let data = {
      fn: "get_payment_token",
      version: 8,
      website: true,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionToken,
      },
    };
    return this.sendRequest(url, request);
  };
  deletePaymentToken = (sessionToken, paymentTokenID) => {
    let url = `${this.HOST_NAME_ICOLUMN}`;
    let data = {
      fn: "remove_payment_token",
      payment_token_id: paymentTokenID,
      version: api_version,
      website: true,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionToken,
      },
    };
    return this.sendRequest(url, request);
  };
  setTodefault = (obj, securityToken) => {
    let url = `${this.HOST_NAME_ICOLUMN}`;
    // security_token: 'xxaSD8lAuEX3r32dddfp3foiowf12TTs',

    let data = {
      fn: "set_default_address",
      // security_token: securityToken,
      address_id: obj.address_id,
      contact_id: obj.contact_id,
      version: api_version,
      website: true,
    };

    let request = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: securityToken,
      },
    };
    return this.sendRequest(url, request);
  };
  updateAddress = (obj, securityToken) => {
    let url = `${this.HOST_NAME_ICOLUMN}`;
    // security_token: 'xxaSD8lAuEX3r32dddfp3foiowf12TTs',
    let data = {
      fn: "update_address",
      // security_token: 'xxaSD8lAuEX3r32dddfp3foiowf12TTs',
      address_id: obj.address_id,
      building_name: obj.building_name,
      contact_id: obj.contact_id,
      contact_name: obj.contact_name,
      contact_number: obj.contact_number,
      postal_code: obj.postal_code,
      block_number: obj.block_number,
      street_name: obj.street_name,
      unit_number: obj.unit_number,
      contact_email: obj.contact_email,
      version: api_version,
      website: true,
    };

    let request = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: securityToken,
      },
    };
    return this.sendRequest(url, request);
  };
  addAddress = (obj, securityToken) => {
    let url = `${this.HOST_NAME_ICOLUMN}`;
    // security_token: 'xxaSD8lAuEX3r32dddfp3foiowf12TTs',
    let data = {
      fn: "add_address",
      // security_token: 'xxaSD8lAuEX3r32dddfp3foiowf12TTs',
      building_name: obj.building_name,
      contact_id: obj.contact_id,
      contact_name: obj.contact_name,
      contact_number: obj.contact_number,
      postal_code: obj.postal_code,
      block_number: obj.block_number,
      street_name: obj.street_name,
      unit_number: obj.unit_number,
      contact_email: obj.contact_email,
      is_default: obj.is_default,
      version: api_version,
      website: true,
    };

    let request = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: securityToken,
      },
    };
    return this.sendRequest(url, request);
  };
  deleteAddress = (obj, securityToken) => {
    let url = `${this.HOST_NAME_ICOLUMN}`;
    // security_token: 'xxaSD8lAuEX3r32dddfp3foiowf12TTs',

    let data = {
      fn: "delete_address",
      // security_token: securityToken,
      address_id: obj.address_id,
      contact_id: obj.contact_id,
      version: api_version,
      website: true,
    };

    let request = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: securityToken,
      },
    };
    return this.sendRequest(url, request);
  };
  getHash = (obj, token) => {
    let url = `${this.HOST_NAME}${this._GET_HASH}`;

    let request = {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    return this.sendRequest(url, request);
  };
  getMerchantShipmentId = (obj) => {
    let url = `${this.HOST_NAME}${this._GET_MERCHANT_SHIPMENT_ID}`;
    let request = {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    };
    return this.sendRequest(url, request);
  };
  setCustomField = (obj,token) => {
    let url = `${this.HOST_NAME}${this._SET_CUSTOMFILEDS}`;
    let request = {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json",
        'Authorization':token
      },
    };
    return this.sendRequest(url, request);
  };
  getAllCategoriesByHerarchy = () => {
    let url = `${this.HOST_NAME}${this._GET_ALL_CATEGORIES_HIERARCHY}`;
    let request = {
      method: "GET",
    };
    return this.sendRequest(url, request);
  };
  getItemsByFilters(body, accessToken) {
    let url = `${this.HOST_NAME}${this._GET_SINGLE_ITEM}`;
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    };
    return this.sendRequest(url, request);
  }
  getAllCategories = () => {
    let url = `${this.HOST_NAME}${this._GET_ALL_CATEGORIES}`;
    let request = {
      method: "GET",
    };
    return this.sendRequest(url, request);
  };
  getShopName = () => {
    let url = `${this.HOST_NAME}${this._GET_SHOP_NAME}`;
    let request = {
      method: "GET",
    };
    return this.sendRequest(url, request);
  };
  getBrandsName = () => {
    let url = `${this.HOST_NAME}${this._GET_BRANDS_NAME}`;
    let request = {
      method: "GET",
    };
    return this.sendRequest(url, request);
  };

  getALlInvoices = (
    userid,
    accessToken,
    pageNumber,
    pageSize,
    _hasItemRefunded,
    inVoiceNo
  ) => {
    let url = `${this.HOST_NAME}gettransactions?userId=${userid}&pageSize=${pageSize}&pageNumber=${pageNumber}&hasItemRefunded=${_hasItemRefunded}&invoiceNo=${inVoiceNo}`;
    let request = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    return this.sendRequest(url, request);
  };
  getSingleInvoice = async (userId, invoiceID, accessToken) => {
    let url = `${this.HOST_NAME}${this._USERS}${userId}/transactions/${invoiceID}`;
    let request = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    return this.sendRequest(url, request);
  };
  getInvoiceStatus = async (invoiceID) => {
    const ACF = await this.getCustomFieldsCode();
    let url = `${this.HOST_NAME}${this._GET_INVOICE_STATUS}${ACF["Orders"]}${this._GET_INVOICE_STATUS_2}?Sort=CreatedDateTime`;
    let body = [
      {
        Name: "invoiceID",
        Operator: "equal",
        Value: invoiceID,
      },
    ];
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        // Authorization: "Bearer " + accessToken,
      },
    };

    return this.sendRequest(url, request);
  };
  getUserDetail = (userId) => {
    let url = `${this.HOST_NAME}${this._USERS}${userId}`;
    let request = {
      method: "GET",
      // headers: {
      //   "Content-Type": "application/json",
      //   Authorization: "Bearer " + accessToken,
      // },
    };
    return this.sendRequest(url, request);
  };
  getAllMerchants = () => {
    let url = `${this.HOST_NAME}${this._GET_ALL_MERCHANTS}`;
    let request = {
      method: "GET",
    };
    return this.sendRequest(url, request);
  };
  getCmsDeepLinkSection = (cms_section) => {
    let url = `${process.env.REACT_APP_FRX_API_URL}/getDeepLink`;
    let data = {
      path_name: cms_section,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    };
    return this.sendRequest(url, request);
  };
  getArticleList = () => {
    let url = `${process.env.REACT_APP_FRX_API_URL}/listarticle`;
    let data = {
      request: {
        fn: "article_list",
        mall_id: "",
        category: "eStore",
        version: api_version,
      },
    };
    let request = {
      method: "GET",
    };
    url = url + "?data=" + encodeURI(JSON.stringify(data)) + "&estore=1";
    return this.sendRequest(url, request);
  };
  getArticleDetail = (_id) => {
    let url = `${process.env.REACT_APP_FRX_API_URL}/listarticle`;
    let data = {
      request: {
        fn: "article_detail",
        id: _id,
      },
    };

    let request = {
      method: "GET",
    };
    url = url + "?data=" + encodeURI(JSON.stringify(data)) + "&estore=1";
    return this.sendRequest(url, request);
  };
  getCustomFieldsCode = async (force = false) => {
    var ACF = "";
    if (force || !localStorage.getItem("ACF")) {
      ACF = await fetch(process.env.REACT_APP_ACF_FILE).then((res) =>
        res.json()
      );
      localStorage.setItem("ACF", JSON.stringify(ACF));
    }

    ACF = JSON.parse(localStorage.getItem("ACF"));
    return ACF;
  };
  getFeaturedProducts = async (accessToken) => {
    const ACF = await this.getCustomFieldsCode();
    let body = {
      CustomFieldQueries: [
        {
          Code: ACF["isFeaturedHome"],
          Operator: "equal",
          Value: "1",
        },
        {
          Code: ACF["isFeatured"],
          Operator: "equal",
          Value: "1",
        },
      ],
      Sort: "-created",
    };

    let response = await this.getItemsByFilters(body, accessToken);
    return response.Records;
  };
  getFeaturedProductsHome = async (accessToken) => {
    const ACF = await this.getCustomFieldsCode();
    let body = {
      CustomFieldQueries: [
        {
          Code: ACF["isFeaturedHome"],
          Operator: "equal",
          Value: "1",
        },
      ],
      Sort: "-created",
    };

    let response = await this.getItemsByFilters(body, accessToken);
    return response.Records;
  };
  getFeaturedStores = async () => {
    let url = `${this.HOST_NAME}${this._GET_FEATURED_STORES}`;
    let request = {
      method: "GET",
    };
    return this.sendRequest(url, request);
  };
  getCarouselBanners() {
    let url = `${process.env.REACT_APP_CAROUSEL_BANNERS_URL}`;
    let request = {
      method: "GET",
    };
    return this.sendRequest(url, request);
  }
  getSettings() {
    let url = `${process.env.REACT_APP_FRX_API_URL}/${this._GET_SETTINGS}?version=${api_version}`;
    let request = {
      method: "GET",
    };
    return this.sendRequest(url, request);
  }
  getTiles() {
    let url = `${process.env.REACT_APP_TILES_URL}`;
    let request = {
      method: "GET",
    };
    console.log("url geturl geturl geturl geturl get", url, request);
    return this.sendRequest(url, request);
  }
  PreJoinSignup(_mobileNumber, _checksum) {
    let url = `${this.HOST_NAME_ICOLUMN}`;
    let body = {
      fn: "pre_join",
      mobilephonenumber: _mobileNumber,
      email: _mobileNumber + "@phonenumber.com",
      estore: true,
      version: api_version,
      checksum: _checksum,
      website: true,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log("URL: ", url, "request: ", request);
    return this.sendRequest(url, request);
  }
  ResendMobileOTP(verification_code, _checksum) {
    let url = `${this.HOST_NAME_ICOLUMN}`;
    let body = {
      fn: "resend_mobile_otp",
      version: api_version,
      checksum: _checksum,
      verification_token: verification_code,
      website: true,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log("URL: ", url, "request: ", request);
    return this.sendRequest(url, request);
  }
  VerifyMobileOTP(verification_code, _checksum, otp) {
    let url = `${this.HOST_NAME_ICOLUMN}`;
    let body = {
      fn: "verify_mobile_otp",
      version: api_version,
      checksum: _checksum,
      otp: otp,
      verification_token: verification_code,
      website: true,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log("URL: ", url, "request: ", request);
    return this.sendRequest(url, request);
  }
  CompleteProfileJoin({ data }) {
    console.log("Data **&&& ", data);
    data["estore"] = true;
    data["version"] = api_version;
    data["website"] = true;
    let url = `${this.HOST_NAME_ICOLUMN}`;
    let request = {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log("URL: ", url, "request: ", request);
    return this.sendRequest(url, request);
  }
  userLogout(jwt_token) {
    let url = `${process.env.REACT_APP_FRX_API_URL}/${this.USER_LOGOUT}`;
    let request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jwt_token,
      },
      body: JSON.stringify({
        website: true
      })
    };
    console.log("URL: ", url, "request: ", request);
    return this.sendRequest(url, request);
  }

  userArcadierLogout(arcadier_token) {
    let url = `${this.HOST_NAME}${this._LOGOUT_ARCADIER_USER}`;
    let request = {
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + arcadier_token,
      },
    };
    console.log("URL: ", url, "request: ", request);
    return this.sendRequest(url, request);
  }

  LoginUser(user_name, _password) {
    let url = `${process.env.REACT_APP_FRX_API_URL}/${this.USER_LOGIN}`;
    let body = {
      version: api_version,
      user_name: user_name,
      password: _password,
      website: true,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log("URL: ", url, "request: ", request);
    return this.sendRequest(url, request);
  }
  recoverCredentials(_username, checksum) {
    let url = `${process.env.REACT_APP_FRX_API_URL}/${this.RECOVER_CREDENTIALS}`;
    let body = {
      nric: _username,
      fn: "get_partial_user_detail",
    };
    let request = {
      method: "POST",
      body: body,
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log("URL: ", url, "request: ", request);
    return this.sendRequest(url, request);
  }
  recoverCredentialsMobile(_mobileNumber, _checksum) {
    let url = `${this.HOST_NAME_ICOLUMN}`;
    let body = {
      fn: "send_mobile_otp",
      mobilephonenumber: _mobileNumber,
      version: api_version,
      checksum: _checksum,
      website: true,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log("URL: ", url, "request: ", request);
    return this.sendRequest(url, request);
  }

  resetNewPassword(_newPassword, _checksum, _verificationToken) {
    let url = `${this.HOST_NAME_ICOLUMN}`;
    let body = {
      fn: "reset_password_secure",
      verification_token: _verificationToken,
      new_password: _newPassword,
      version: api_version,
      checksum: _checksum,
      website: true,
    };
    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    };
    console.log("URL: ", url, "request: ", request);
    return this.sendRequest(url, request);
  }
  getPopOvers() {
    let frhubAddress = "";
    if (process.env.REACT_APP_ENV == "prod") {
      frhubAddress = "https://frasershub-api.tgate.sg/api/";
    } else {
      frhubAddress = "https://tokri-api.spoonspace.com/api/";
    }

    let url = `${frhubAddress}${this.TOKRI_POPOVERS}`;
    let request = {
      method: "GET",
    };
    console.log("getPopOvers URL: ", url, "request", request);
    return this.sendRequest(url, request);
  }
  getFeaturedBrands() {
    let frhubAddress = "";
    if (process.env.REACT_APP_ENV == "prod") {
      frhubAddress = "https://frasershub-api.tgate.sg/api/";
    } else {
      frhubAddress = "https://tokri-api.spoonspace.com/api/";
    }
    let url = `${frhubAddress}${this.TOKRI_FEATUREDBRANDS}`;
    console.log("Featured Brands url", process.env.REACT_APP_ENV);
    let request = {
      method: "GET",
    };
    console.log("getFeaturedBrands URL: ", url, "request", request);
    return this.sendRequest(url, request);
  }
  getMenuBanners() {
    let frhubAddress = "";
    if (process.env.REACT_APP_ENV == "prod") {
      frhubAddress = "https://frasershub-api.tgate.sg/api/";
    } else {
      frhubAddress = "https://tokri-api.spoonspace.com/api/";
    }
    let url = `${frhubAddress}${this.TOKRI_MENUBANNERS}`;
    let request = {
      method: "GET",
    };
    console.log("getMenuBanners URL: ", url, "request", request);
    return this.sendRequest(url, request);
  }
  getShoutouts() {
    let frhubAddress = "";
    if (process.env.REACT_APP_ENV == "prod") {
      frhubAddress = "https://frasershub-api.tgate.sg/api/";
    } else {
      frhubAddress = "https://tokri-api.spoonspace.com/api/";
    }
    let url = `${frhubAddress}${this.TOKRI_SHOUTOUTS}`;
    let request = {
      method: "GET",
    };
    console.log("getSHoutouts URL: ", url, "request", request);
    return this.sendRequest(url, request);
  }

  getAppSettings() {
    let url = "";
    if (process.env.REACT_APP_ENV == "prod") {
      url = "https://frxapi.tgate.sg/live/";
    } else {
      url = "https://frxapi-stage.tgate.sg/live/";
    }
    url = url + "get_app_settings?version=19";
    let request = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return this.sendRequest(url, request);
  }

  getMemberInfo(request){
    let url = "";
    if (process.env.REACT_APP_ENV == "prod") {
      url = "https://frxapi.tgate.sg/live/";
    } else {
      url = "https://frxapi-stage.tgate.sg/live/";
    }
    url = url + "user/memberinfo";
    return this.sendRequest(url, request);
  }

  applyingPromoCode(
    token,
    code,
    contact_id,
    products,
    totalAmount,
    totalQuantity
  ) {
    let tokriSpoonSpace = "";
    if (process.env.REACT_APP_ENV == "prod") {
      tokriSpoonSpace = "https://frasershub-api.tgate.sg/api/";
    } else {
      tokriSpoonSpace = "https://tokri-api.spoonspace.com/api/";
    }
    let url = `${tokriSpoonSpace}${this.TOKRI_VERIFY_CODE}`;
    var urlencoded = new URLSearchParams();
    urlencoded.append("code", code);
    urlencoded.append("contact_id", contact_id);
    urlencoded.append("products", JSON.stringify(products));
    urlencoded.append("amount", totalAmount);
    urlencoded.append("quantity", totalQuantity);
    let request = {
      method: "POST",
      body: urlencoded,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    return this.sendRequest(url, request);
  }
}
